export default __webpack_public_path__ + "8118452e19fa8a1b47920b40b090926f.png";